import { useCallback } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import PATHS from '../../routes/routes.const';

type DeepPaths<T> = {
  [K in keyof T]: T[K] extends { path: string }
    ? T[K]['path'] | (T[K] extends { [subkey: string]: unknown } ? DeepPaths<T[K]> : string)
    : string;
}[keyof T];

const usePath = () => {
  const { pathname } = useLocation();

  const isPath = useCallback(
    (path: DeepPaths<typeof PATHS>) => {
      return !!matchPath(pathname, path)?.isExact;
    },
    [pathname],
  );

  return { isPath };
};

export default usePath;
